import { CSSTransition } from "react-transition-group";

import { cx } from "@/utils";

import styles from "./Backdrop.module.css";
export interface BackdropProps extends React.HTMLProps<HTMLDivElement> {
  className?: string;
  open?: boolean;
  onClick?: () => void;
}

const TRANSITION_KEY = "backdrop-transition";

/**
 * Backdrop
 * Adds a semi-transparent overlay
 */

const Backdrop: React.FunctionComponent<BackdropProps> = ({
  open = true,
  onClick,
  className,
  ...rest
}) => {
  return (
    <CSSTransition
      unmountOnExit
      mountOnEnter
      in={open}
      timeout={open ? 0 : 125}
      classNames={{
        enter: styles.in,
        enterDone: styles.visible,
        enterActive: styles.visible,
        exitDone: styles.exitDone,
        exitActive: styles.hidden,
      }}
    >
      <div
        key={TRANSITION_KEY}
        className={cx(styles.root, className)}
        onClick={onClick}
        {...rest}
      />
    </CSSTransition>
  );
};

export default Backdrop;
